import React, { CSSProperties } from 'react';

interface IImgWithFallbackProps {
    src: string
    fallbackSrc: string
    alt?: string
    onClick?: () => void
    styles?: CSSProperties
    classNames?: string
}

const ImgWithFallback = ({ src, fallbackSrc, alt, onClick, styles, classNames }: IImgWithFallbackProps) => {
    return (
        <picture>
            <source srcSet={src} type='image/webp' onClick={onClick} style={styles} />
            <img src={fallbackSrc} alt={alt ? alt : 'img'} onClick={onClick} style={styles} className={classNames} />
        </picture>
    );
};

export default ImgWithFallback;